// extracted by mini-css-extract-plugin
export default {"paymentFoldSuccess":"paymentFoldSuccess-9302","margintop":"margintop-0d85","money":"money-6320","bold":"bold-fcd2","nobottompadding":"nobottompadding-eb24"};